/**
 * The WigAntLayout frame the reports pages share — the same full-height,
 * sider-less shell the admin screens use.
 */
export const reportLayoutProps = (darkMode) => ({
  darkMode,
  layoutStyle: {
    height: "93vh",
    width: "99vw",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  },
  contentStyle: { minHeight: "70vh", overflow: "auto", padding: 12, margin: 0 },
  showFooter: false,
  showHeader: false,
  siderProps: { collapsible: true, collapsed: true, width: 0 },
  showDefaultMenu: false,
});

export default reportLayoutProps;
